const IMG =
  "https://images.unsplash.com/photo-1776928161672-add9fc520430?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxkYXJrJTIwY2luZW1hdGljJTIwZm9vZCUyMGluZ3JlZGllbnRzfGVufDB8fHx8MTc3ODYwOTQwNnww&ixlib=rb-4.1.0&q=85";

export const About = () => (
  <section
    id="despre-noi"
    data-testid="about-section"
    className="relative py-20 sm:py-28 bg-[#080706]"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
      <div className="lg:col-span-7">
        <p className="text-xs font-semibold tracking-[0.32em] uppercase text-[#C8A97E] mb-6">
          — Despre Noi
        </p>
        <h2 className="font-[Playfair_Display] text-[#FDF8F5] text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.08] tracking-tight">
          Tradiție <em className="italic text-[#C8A97E]">&amp;</em> Excelență
          <br />
          într-un singur loc.
        </h2>
        <p className="mt-8 text-[#A8A29E] text-base sm:text-lg font-light leading-relaxed max-w-xl">
          Suntem partenerul de încredere pentru restaurante, hoteluri și
          retaileri din toată România. Oferim o gamă vastă de produse
          alimentare en-gros, atent selecționate, garantând prospețimea și
          calitatea de top la fiecare livrare.
        </p>
        <p className="mt-4 text-[#A8A29E] text-base sm:text-lg font-light leading-relaxed max-w-xl">
          Cu o experiență construită pe relații solide cu producători
          consacrați, livrăm constant — în orice cantitate, oriunde ai
          nevoie.
        </p>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-6 border-t border-[#1F1A18] pt-8 max-w-xl">
          {[
            { n: "20+", l: "Ani experiență" },
            { n: "500+", l: "Clienți B2B" },
            { n: "100%", l: "Stoc garantat" },
          ].map((s) => (
            <div key={s.l}>
              <div className="font-[Playfair_Display] text-2xl text-[#FDF8F5]">{s.n}</div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#A8A29E] mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="lg:col-span-5 relative">
        <div className="relative aspect-[4/5] overflow-hidden">
          <img
            src={IMG}
            alt="Ingrediente premium"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#080706] via-transparent to-transparent" />
        </div>
        <div className="absolute -bottom-6 -left-6 hidden sm:block bg-[#080706] border border-[#C8A97E]/40 px-6 py-4">
          <p className="text-xs uppercase tracking-[0.25em] text-[#C8A97E]">
            Furnizor verificat
          </p>
          <p className="font-[Playfair_Display] text-[#FDF8F5] text-lg italic mt-1">
            din 2004
          </p>
        </div>
      </div>
    </div>
  </section>
);
